import { createDragDropManager } from 'dnd-core';
import { MultiBackend, getBackendOptions } from '@minoru/react-dnd-treeview';

export const manager = createDragDropManager(
  MultiBackend,
  null,
  getBackendOptions(),
);
